function getURLVar(key) {
  var value = [];

  var query = String(document.location).split('?');

  if (query[1]) {
    var part = query[1].split('&');

    for (i = 0; i < part.length; i++) {
      var data = part[i].split('=');

      if (data[0] && data[1]) {
        value[data[0]] = data[1];
      }
    }

    if (value[key]) {
      return value[key];
    } else {
      return '';
    }
  }
}
function isEmpty( el ){
  return !$.trim(el.html())
}
$(document).ajaxStop(function() {
  function isEmpty( el ){
    return !$.trim(el.html())
  }
  if (!isEmpty($('#product'))) {
    $('#product .option-container').addClass('has-option');      
  }	
});

// Sidebar filter setup start
function replaceUrlParam(url, paramName, paramValue) {
  let pattern = new RegExp("\\b(" + paramName + "=).*?(&|$)");
  if (url.search(pattern) >= 0) {
    return url.replace(pattern, "$1" + paramValue + "$2");
  }
  return url + (url.indexOf("?") > 0 ? "&" : "?") + paramName + "=" + paramValue;
}

function filterCollParam(url, loader = true) {
  const wraperAjax = document.getElementById("wraper_ajax");
  loader && wraperAjax.classList.add("show");
  fetch(url)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.text();
    })
    .then((responseText) => {
      const parser = new DOMParser();
      const responseDoc = parser.parseFromString(responseText, "text/html");

      if (loader) {
        updateElementContent(responseDoc, "#custom-products", "custom-products");
      } else {
        updateElementContent(responseDoc, "#custom-products", "custom-products", true); // for loadmore pagination
      }
      updateElementContent(responseDoc, "#toolbar-products", "toolbar-products");
      updateElementContent(responseDoc, "#column-left", "column-left");
      updateElementContent(responseDoc, "#pagination", "pagination");
      //updateElementContent(responseDoc, "#top_filter_bar", "top_filter_bar");
      //updateElementContent(responseDoc, "#side_filter_bar", "side_filter_bar");
      //updateElementContent(responseDoc, "#active-filters", "active-filters");
      //updateElementContent(responseDoc, "#collection-amount", "collection-amount");

      handleLocalStorageView();

      history.pushState({ page: url }, url, url);

      loader && wraperAjax.classList.remove("show");

      if(window.SPR) {
      SPR?.registerCallbacks();
      SPR?.initRatingHandler();
      SPR?.initDomEls();
      SPR?.loadProducts();
      SPR?.loadBadges();
      }
      initSlider();

      // Handle Wishlist
      

      //filterAttributeHandler();
    })
    .catch((error) => {
      console.error("Fetch error: ", error);
      loader && wraperAjax.classList.remove("show");
    });
}

function updateElementContent(responseDoc, sourceSelector, targetId, isPagination = false) {
  const source = responseDoc.querySelector(sourceSelector);
  const target = document.getElementById(targetId);
  if (source && source.innerHTML.trim() && target) {
    if (isPagination) {
      target.innerHTML += source.innerHTML;
    } else {
      target.innerHTML = source.innerHTML;
    }
  }
}

function updateInnerHtml(selector, sourceDoc) {
  const targetElement = document.querySelector(selector);
  if (targetElement && sourceDoc.querySelector(selector)) {
    targetElement.innerHTML = sourceDoc.querySelector(selector).innerHTML;
  }
}

function handleLocalStorageView() {
  const typeElement = document.getElementById("category-view-type");
  const colsElement = document.getElementById("category-grid-cols");
  if (typeElement && colsElement) {
    const type = typeElement.value;
    const cols = colsElement.value;

    if (!localStorage.getItem("type")) {
      if (cols) {
        if (type === "list") {
          category_view.initView(type, cols, "btn-list");
          //category_view.customPriceBoxList();
        } else if (type === "grid") {
          category_view.initView(type, cols, "btn-grid-" + cols);
          //category_view.customPriceBoxGrid();
        }
      }
    } else {
      const storedType = localStorage.getItem("type");
      const element = localStorage.getItem("element");
      const storedCols = localStorage.getItem("cols");
      category_view.initView(storedType, storedCols, element);
    }
  }
}
// Sidebar filter setup end
// resize code for equal size grids and content start
var img_ratio = 1.0/1.0;


$(document).ready(function() {

  

  // sidebar mobile toggle code start 
  if ($(window).width() <=991 ) {

    $('#sidebar-toggle .oc-menu-bar').click(function (e) {
      e.stopPropagation();
      var effect = $(this).closest('#sidebar-toggle.oc-menu').find('.menu-effect').val();
      $('#column-left').addClass('sidebar-toggle');
      $('.sidebar-overlay').toggle();
      if(effect == "none") {
        $('#column-left').toggle();
      }

      if(effect == "fade") {
        $('#column-left').fadeToggle();
      }

      if(effect == "slide") {
        $('#column-left').slideToggle();
      }

    });

    $('#column-left').click(function(e){
      e.stopPropagation();
    });

    $(document.body).click(function(e){
      var effect = $('#sidebar-toggle.oc-menu').find('.menu-effect').val();
      $('.sidebar-overlay').hide();
      if(effect == "none") {
        $('#column-left').hide();
      }
      if(effect == "fade") {
        $('#column-left').fadeOut();
      }
      if(effect == "slide") {
        $('#column-left').slideUp();
      }
    });
  }
  // sidebar mobile toggle code end

  // Adding active class for mobtabs on mobile layout
  $('.mobtab a').click(function(e){
    $('.mobtab a').removeClass('active');
    $(this).addClass('active');
  });

  // product video 
  $('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
  });

  // Function to disable all purchase buttons
  function disablePurchaseButtons() {
    var $addToCart = $('#button-cart');
    var $addToCartBuy = $('#button-cart-buy');
    var $addToCartSticky = $('#button-cart-sticky');
    var $shopifyPaymentButton = $('.shopify-payment-button__button');
    var $shopifyPaymentButtonContainer = $('.shopify-payment-button');
    
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartBuy.addClass('disabled').prop('disabled', true);
    $addToCartSticky.addClass('disabled').prop('disabled', true);
    
    // Disable/hide Shopify payment button
    $shopifyPaymentButton.prop('disabled', true).css('pointer-events', 'none').css('opacity', '0.5');
    $shopifyPaymentButtonContainer.css('pointer-events', 'none').css('opacity', '0.5');
    
    // Update button text if needed
    if (typeof selectCallback === 'undefined') {
      $addToCart.html($addToCart.data('sold-out-text') || 'Sold Out');
      $addToCartBuy.html($addToCartBuy.data('sold-out-text') || 'Sold Out');
      $addToCartSticky.html($addToCartSticky.data('sold-out-text') || 'Sold Out');
    }
  }
  
  // Function to enable all purchase buttons
  function enablePurchaseButtons() {
    var $addToCart = $('#button-cart');
    var $addToCartBuy = $('#button-cart-buy');
    var $addToCartSticky = $('#button-cart-sticky');
    var $shopifyPaymentButton = $('.shopify-payment-button__button');
    var $shopifyPaymentButtonContainer = $('.shopify-payment-button');
    
    $addToCart.removeClass('disabled').prop('disabled', false);
    $addToCartBuy.removeClass('disabled').prop('disabled', false);
    $addToCartSticky.removeClass('disabled').prop('disabled', false);
    
    // Enable Shopify payment button
    $shopifyPaymentButton.prop('disabled', false).css('pointer-events', 'auto').css('opacity', '1');
    $shopifyPaymentButtonContainer.css('pointer-events', 'auto').css('opacity', '1');
  }

  // color swatch js snippet
  $('.swatch :radio').change(function() {
    var optionIndex = $(this).closest('.swatch').attr('data-option-index');
    var optionValue = $(this).val();
    var $swatchElement = $(this).closest('.swatch-element');
    var isSoldOut = $swatchElement.hasClass('soldout');
    var $swatch = $(this).closest('.swatch');
    var $selectedColorValue = $swatch.find('.selected-color-value');
    
    // Keep sold out swatches clickable and still push selection
    // into variant selector state so SKU/variant details can update.
    if (isSoldOut) {
      if ($selectedColorValue.length) {
        $selectedColorValue.text(optionValue);
      }
      disablePurchaseButtons();
    }
    
    $(this)
    .closest('form')
    .find('.single-option-selector')
    .eq(optionIndex)
    .val(optionValue)
    .trigger('change');
    
    // Update selected color name display
    if ($selectedColorValue.length) {
      $selectedColorValue.text(optionValue);
    }
    
    // Check if selected variant is available after a short delay to allow variant selection to update
    setTimeout(function() {
      var selectedVariantId = $('#productSelect').val();
      var $selectedOption = $('#productSelect option:selected');
      var isVariantAvailable = selectedVariantId && !$selectedOption.prop('disabled') && $selectedOption.val() !== '';
      
      // Also check if the swatch element itself is marked as soldout
      if (isSoldOut || !isVariantAvailable) {
        disablePurchaseButtons();
      } else {
        enablePurchaseButtons();
      }
    }, 100);
  });
  
  // Also listen to productSelect changes to ensure button state is correct
  $(document).on('change', '#productSelect', function() {
    var $selectedOption = $(this).find('option:selected');
    var isDisabled = $selectedOption.prop('disabled') || !$selectedOption.val() || $selectedOption.val() === '';
    
    if (isDisabled) {
      disablePurchaseButtons();
    } else {
      // Check if any swatch is marked as soldout for the current selection
      var selectedOptions = [];
      $('.swatch :radio:checked').each(function() {
        selectedOptions.push($(this).val());
      });
      
      // Check if current swatch selection has soldout class
      var hasSoldOutSwatch = false;
      $('.swatch :radio:checked').each(function() {
        if ($(this).closest('.swatch-element').hasClass('soldout')) {
          hasSoldOutSwatch = true;
          return false;
        }
      });
      
      if (!hasSoldOutSwatch) {
        enablePurchaseButtons();
      }
    }
  });
  
  // Check on page load if initial variant is sold out
  $(document).ready(function() {
    setTimeout(function() {
      var selectedVariantId = $('#productSelect').val();
      var $selectedOption = $('#productSelect option:selected');
      var isDisabled = $selectedOption.prop('disabled') || !$selectedOption.val() || $selectedOption.val() === '';
      
      // Also check if any selected swatch is sold out
      var hasSoldOutSwatch = false;
      $('.swatch :radio:checked').each(function() {
        if ($(this).closest('.swatch-element').hasClass('soldout')) {
          hasSoldOutSwatch = true;
          return false;
        }
      });
      
      if (isDisabled || hasSoldOutSwatch) {
        disablePurchaseButtons();
      }
    }, 200);
  });
  
  // Prevent Shopify payment button clicks when disabled
  $(document).on('click', '.shopify-payment-button__button', function(e) {
    if ($(this).prop('disabled') || $(this).css('pointer-events') === 'none') {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  });

  // product page add to cart
  $('#button-cart').on('click', function(e) {
    e.preventDefault();
    
    // Prevent adding sold-out products
    if ($(this).hasClass('disabled') || $(this).prop('disabled')) {
      toastr.warning("Sold Out");
      return false;
    }
    
    // Check if selected variant is available
    var selectedVariantId = $('#productSelect').val();
    if (!selectedVariantId) {
      toastr.warning("Unavailable");
      return false;
    }
    
    $.ajax({
      url: '/cart/add.js',
      type: 'post',
      data: $('#form_buy').serialize(),
      dataType: 'json',
      beforeSend: function() {
        $('#button-cart').button('loading');
      },
      complete: function() {
        $('#button-cart').button('reset');
      },
      success: function(json) {
        $('.alert, .text-danger').remove();
        $('.form-group').removeClass('has-error');

        if (json['error']) {
          if (json['error']['option']) {
            for (i in json['error']['option']) {
              var element = $('#input-option' + i.replace('_', '-'));
              if (element.parent().hasClass('input-group')) {
                element.parent().after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
              } else {
                element.after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
              }
            }
          }

          if (json['error']['recurring']) {
            $('select[name=\'recurring_id\']').after('<div class="text-danger">' + json['error']['recurring'] + '</div>');
          }

          // Highlight any found errors
          $('.text-danger').parent().addClass('has-error');
        }

        toastr.success('Hooray! Your item has been added.');

                       $.getJSON('/cart.js', function(cart) {
          load(cart);
        });

        $('html, body').animate({ scrollTop: 0 }, 'slow');

      },
      error: function(xhr, ajaxOptions, thrownError) {
        if(xhr.status == 422 ) {
          var errorMessage = "Item variant already added to the cart.";
          try {
            var response = JSON.parse(xhr.responseText);
            if (response.description && response.description.toLowerCase().indexOf('sold out') !== -1) {
              errorMessage = "Sold Out";
            } else if (response.description) {
              errorMessage = response.description;
            }
          } catch(e) {}
          toastr.warning(errorMessage);
        } else {
          alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
        }
      }
    });
  });

  $('#button-cart-sticky').on('click', function(e) {
    e.preventDefault();
    
    // Prevent adding sold-out products
    if ($(this).hasClass('disabled') || $(this).prop('disabled')) {
      toastr.warning("Sold Out");
      return false;
    }
    
    // Check if selected variant is available
    var selectedVariantId = $('#productSelect').val();
    if (!selectedVariantId) {
      toastr.warning("Unavailable");
      return false;
    }
    
    $.ajax({
      url: '/cart/add.js',
      type: 'post',
      data: $('#form_buy').serialize(),
      dataType: 'json',
      beforeSend: function() {
        $('#button-cart-sticky').button('loading');
      },
      complete: function() {
        $('#button-cart-sticky').button('reset');
      },
      success: function(json) {
        $('.alert, .text-danger').remove();
        $('.form-group').removeClass('has-error');

        if (json['error']) {
          if (json['error']['option']) {
            for (i in json['error']['option']) {
              var element = $('#input-option' + i.replace('_', '-'));
              if (element.parent().hasClass('input-group')) {
                element.parent().after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
              } else {
                element.after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
              }
            }
          }

          if (json['error']['recurring']) {
            $('select[name=\'recurring_id\']').after('<div class="text-danger">' + json['error']['recurring'] + '</div>');
          }

          // Highlight any found errors
          $('.text-danger').parent().addClass('has-error');
        }

        toastr.success('Hooray! Your item has been added.');

                       $.getJSON('/cart.js', function(cart) {
          load(cart);
        });

        $('html, body').animate({ scrollTop: 0 }, 'slow');

      },
      error: function(xhr, ajaxOptions, thrownError) {
        if(xhr.status == 422 ) {
          var errorMessage = "Item variant already added to the cart.";
          try {
            var response = JSON.parse(xhr.responseText);
            if (response.description && response.description.toLowerCase().indexOf('sold out') !== -1) {
              errorMessage = "Sold Out";
            } else if (response.description) {
              errorMessage = response.description;
            }
          } catch(e) {}
          toastr.warning(errorMessage);
        } else {
          alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
        }
      }
    });
  });

  $('#button-cart-buy').on('click', function(e) {
    e.preventDefault();
    
    // Prevent adding sold-out products
    if ($(this).hasClass('disabled') || $(this).prop('disabled')) {
      toastr.warning("Sold Out");
      return false;
    }
    
    // Check if selected variant is available
    var selectedVariantId = $('#productSelect').val();
    if (!selectedVariantId) {
      toastr.warning("Unavailable");
      return false;
    }
    
    $.ajax({
      url: '/cart/add.js',
      type: 'post',
      data: $('#form_buy').serialize(),
      dataType: 'json',
      beforeSend: function() {
        $('#button-cart-buy').button('loading');
      },
      complete: function() {
        $('#button-cart-buy').button('reset');
      },
      success: function(json) {
        $('.alert, .text-danger').remove();
        $('.form-group').removeClass('has-error');

        if (json['error']) {
          if (json['error']['option']) {
            for (i in json['error']['option']) {
              var element = $('#input-option' + i.replace('_', '-'));
              if (element.parent().hasClass('input-group')) {
                element.parent().after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
              } else {
                element.after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
              }
            }
          }

          if (json['error']['recurring']) {
            $('select[name=\'recurring_id\']').after('<div class="text-danger">' + json['error']['recurring'] + '</div>');
          }

          // Highlight any found errors
          $('.text-danger').parent().addClass('has-error');
        }

        $.getJSON('/cart.js', function(cart) {
          window.top.location.href="/checkout";
        });

      },
      error: function(xhr, ajaxOptions, thrownError) {
        if(xhr.status == 422 ) {
          var errorMessage = "Item variant already added to the cart.";
          try {
            var response = JSON.parse(xhr.responseText);
            if (response.description && response.description.toLowerCase().indexOf('sold out') !== -1) {
              errorMessage = "Sold Out";
            } else if (response.description) {
              errorMessage = response.description;
            }
          } catch(e) {}
          toastr.warning(errorMessage);
        } else {
          alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
        }
      }
    });
  });

  //stickyMenu();
  var headerSpaceH = $('header').outerHeight(true);
  $('header').after('<div class="headerSpace unvisible" style="height:'+headerSpaceH+'px;"></div>');	

  // Scroll
  var currentP = 0;
  var stickyOffset = 0;
  var stickyOffset1 = 0;

  stickyOffset = $('header').offset().top;
  stickyOffset += $('header').outerHeight();
  stickyOffset += 30;

  if (!isEmpty($('#product-product'))) {
    stickyOffset1 = $('#form_buy').offset().top;
    stickyOffset1 += $('#form_buy').outerHeight();
  }
  $(window).scroll(function(){
    var headerH = $('header').height();
    var scrollP = $(window).scrollTop();
    var winInnW = window.innerWidth;
    if( winInnW > 991 ){
      if(scrollP != currentP){
        //Sticky header

        if(scrollP >= stickyOffset){
          $('.fix').addClass('fix-header');

          $('.headerSpace').removeClass('unvisible');
        } else {
          $('.fix').removeClass('fix-header');

          $('.headerSpace').addClass('unvisible');
        }

        currentP = $(window).scrollTop();
      }
    }

    if (!isEmpty($('#product-product'))) {

      if(scrollP >= stickyOffset1){
        $('.form_buy_sticky').addClass('fix-header2');
        $('.form_buy_sticky').addClass('fix-header1');
        $('html').css('padding-bottom','64px');
      } else {
        $('.form_buy_sticky').removeClass('fix-header1');
        $('.form_buy_sticky').removeClass('fix-header2');
        $('html').css('padding-bottom','0px');
      } 
    }

  });

  if (!isEmpty($('#product'))) {
    $('#product .option-container').addClass('has-option');      
  }
  if (!isEmpty($('#product2'))) {
    $('#product2 .option-container').addClass('has-option');      
  }

  // move breadcrumbs
  $("header").after('<div class="breadcrumbs"><div class="container"></div></div>');	
  var breadcrumb = $('ul.breadcrumb');
  var breadcrumbs_container = $('.breadcrumbs .container');
  breadcrumb.appendTo(breadcrumbs_container);

  // Highlight any found errors
  $('.text-danger').each(function() {
    var element = $(this).parent().parent();

    if (element.hasClass('form-group')) {
      element.addClass('has-error');
    }
  });

  /* Search */
  //$('#search-by-category input[name=\'q\']').parent().find('button').on('click', function() {
  $('#btn-search-category').click(function () {
    var url = '/search';
    var value = $('header #search-by-category input[name=\'q\']').val();
    type = 'product';
    if(value == "Search all products..." || value ==""){
      jQuery('#search-by-category input[name=\'q\']').focus();
      return false;
    }else {
      url += '?type=' + type + '&q=' + encodeURIComponent(value);
    }
    location = url;
  });

  $('#search-by-category input[name=\'q\']').on('keydown', function(e) {
    if (e.keyCode == 13) {
      $('#btn-search-category').trigger('click');
    }
  });
  $('#search').click(function () {
    var url = '/search';
    var type = $('#search input[name=\'type\']').val();
    var value = $('#search.blog input[name=\'q\']').val();
    if(value == "Search all products..." || value ==""){
      jQuery('#search input[name=\'q\']').focus();
      return false;
    }else {
      url += '?type=' + type + '&q=' + encodeURIComponent(value);
    }
    location = url;
  });
  $('#search input[name=\'q\']').on('keydown', function(e) {
    if (e.keyCode == 13) {
      $('#search.blog input[name=\'q\']').parent().find('button').trigger('click');        
    }
  });

  // Menu
  $('#menu .dropdown-menu').each(function() {
    var menu = $('#menu').offset();
    var dropdown = $(this).parent().offset();

    var i = (dropdown.left + $(this).outerWidth()) - (menu.left + $('#menu').outerWidth());

    if (i > 0) {
      $(this).css('margin-left', '-' + (i + 10) + 'px');
    }
  });

  // Product List
  $('#list-view').click(function() {
    $('#content .product-grid > .clearfix').remove();

    $('#content .row > .product-grid').attr('class', 'product-layout product-list col-xs-12');
    $('#grid-view').removeClass('active');
    $('#list-view').addClass('active');

    localStorage.setItem('display', 'list');
    localStorage.setItem('type', 'none');
  });

  // Product Grid
  $('#grid-view').click(function() {
    var cols = $('#column-right, #column-left').length;

    if (cols == 2) {
      $('#content .product-list').attr('class', 'product-layout product-grid module-style1 col-lg-6 col-md-6 col-sm-6 col-xs-6');
    } else if (cols == 1) {
      $('#content .product-list').attr('class', 'product-layout product-grid module-style1 col-lg-4 col-md-4 col-sm-6 col-xs-6');
    } else {
      $('#content .product-list').attr('class', 'product-layout product-grid module-style1 col-lg-3 col-md-3 col-sm-6 col-xs-6');
    }

    $('#list-view').removeClass('active');
    $('#grid-view').addClass('active');

    localStorage.setItem('display', 'grid');
    localStorage.setItem('type', 'none');
  });

  if (localStorage.getItem('display') == 'list') {
    $('#list-view').trigger('click');
    $('#list-view').addClass('active');
  } else {
    $('#grid-view').trigger('click');
    $('#grid-view').addClass('active');
  }

  // module-style1

  $('.module-style1 .item').mouseover(function() {
    $(this).closest('.module-style1').addClass('active');
  });
  $('.module-style1 .item').mouseout(function() {
    $(this).closest('.module-style1').removeClass('active');
  });

  // Checkout
  $(document).on('keydown', '#collapse-checkout-option input[name=\'email\'], #collapse-checkout-option input[name=\'password\']', function(e) {
    if (e.keyCode == 13) {
      $('#collapse-checkout-option #button-login').trigger('click');
    }
  });

  // tooltips on hover
  $('[data-toggle=\'tooltip\']').tooltip({container: 'body'});

  // Makes tooltips work on ajax generated content
  $(document).ajaxStop(function() {
    $('[data-toggle=\'tooltip\']').tooltip({container: 'body'});
  });
});

// Cart add remove functions
var cart = {
  'add': function(product_id, quantity) {
    $.ajax({
      url: '/cart/add.js',
      type: 'post',
      data: 'id=' + product_id + '&quantity=' + (typeof(quantity) != 'undefined' ? quantity : 1),
      dataType: 'json',
      beforeSend: function() {
        var btn = $(this);
        $('.btn-cart > .button').button('loading');
      },
      complete: function() {
        $('.btn-cart > .button').button('reset');
      },
      success: function(json) {
        $('.alert, .text-danger').remove();

        if (json['redirect']) {
          location = json['redirect'];
        }

        toastr.success('Hooray! Your item has been added.');

                       $.getJSON('/cart.js', function(cart) {
          load(cart);
        });

      },
      error: function(xhr, ajaxOptions, thrownError) {
        if(xhr.status == 422 ) {
          toastr.warning('Item variant already added to the cart.');
                         } else {
                         alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
        }
      }
    });
  },
  'remove': function(key) {
    $.ajax({
      url: '/cart/update.js',
      type: 'post',
      data: 'updates['+key+']=0',
      dataType: 'json',
      beforeSend: function() {
        //$('#cart > button').button('loading');
      },
      success: function(json) {
        $('#cart > button').button('reset');

        if (getURLVar('route') == '/cart' || getURLVar('route') == '/checkout') {
          location = '/cart';
        } else {
          setTimeout(function () {
            load(json);
          }, 5);       
        }
      },
      error: function(xhr, ajaxOptions, thrownError) {
        alert(xhr.responseText);
      }
    });
  }
}

function load(cart){
  $('#cart .dropdown-menu > li:first-child .table > tbody > tr').remove();
  $.each(cart.items, function (index, cartItem) {
    var line = index + 1;
    var cents = "";

    if (cartItem.price % 100 < 10) {
      cents = "0";
    }
    var price = parseInt(cartItem.price / 100) + "." + cents + cartItem.price % 100;

    var cartRemove = 'onclick="cart.remove(\''+cartItem.id+'\')"';
    var cartItem = "<tr><td class='text-center'><a href='" + cartItem.url + "' title='" + cartItem.title + "'><img class='cart-image' src='" + cartItem.image + "' alt='" + cartItem.title + "' title='" + cartItem.title + "'></a></td><td class='text-left info-item'><a class='cart-name' href='" + cartItem.url + "'>" + cartItem.title + "</a><p class='cart-quantity'>" + cartItem.quantity + "&nbsp;×&nbsp;</p><p class='cart-price'><span class='money'>" + Shopify.formatMoney(price,moneyFormat) + "</span></p></td><td class='text-center cart-close'><button type='button' "+cartRemove+"' title='Remove' class='btn btn-danger btn-xs'><i class='ion-android-close'></i></button></td></tr>";
    $('#cart .dropdown-menu > li:first-child .table > tbody').append(cartItem);
  });
  if (cart.item_count < 1) {
    $('#cart .dropdown-menu > li:first-child .table > tbody').append('<p class="text-center cart-empty">Nothing to see here :(</p>');
                                                                     $('#cart .dropdown-menu li:not(:first-child):last-child').removeClass('show');
    $('#cart .dropdown-menu li:not(:first-child):last-child').addClass('hide');
  } else {
    $('#cart .dropdown-menu p.cart-empty').remove();
    $('#cart .dropdown-menu li:not(:first-child):last-child').removeClass('hide');
    $('#cart .dropdown-menu li:not(:first-child):last-child').addClass('show');
  }
  $('#cart > button #cart-total').html(cart.item_count);
  $('#cart > button .total-price').html('<span class=money>'+Shopify.formatMoney(cart.total_price, moneyFormat)+'</span>');
  $('#cart-subtotal').html('<span class=money>'+Shopify.formatMoney(cart.total_price, moneyFormat)+'</span>');
  
  if (Currency.cookie.read() != null) {
    Currency.convertAll(shopCurrency, Currency.cookie.read());
  }
  
}

/* Agree to Terms */
$(document).delegate('.agree', 'click', function(e) {
  e.preventDefault();

  $('#modal-agree').remove();

  var element = this;

  $.ajax({
    url: $(element).attr('href'),
    type: 'get',
    dataType: 'html',
    success: function(data) {
      html  = '<div id="modal-agree" class="modal">';
      html += '  <div class="modal-dialog">';
      html += '    <div class="modal-content">';
      html += '      <div class="modal-header">';
      html += '        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>';
      html += '        <h4 class="modal-title">' + $(element).text() + '</h4>';
      html += '      </div>';
      html += '      <div class="modal-body">' + data + '</div>';
      html += '    </div>';
      html += '  </div>';
      html += '</div>';

      $('body').append(html);

      $('#modal-agree').modal('show');
    }
  });
});

// Autocomplete */
(function($) {
  $.fn.autocomplete = function(option) {
    return this.each(function() {
      this.timer = null;
      this.items = new Array();

      $.extend(this, option);

      $(this).attr('autocomplete', 'off');

      // Focus
      $(this).on('focus', function() {
        this.request();
      });

      // Blur
      $(this).on('blur', function() {
        setTimeout(function(object) {
          object.hide();
        }, 200, this);
      });

      // Keydown
      $(this).on('keydown', function(event) {
        switch(event.keyCode) {
          case 27: // escape
            this.hide();
            break;
          default:
            this.request();
            break;
        }
      });

      // Click
      this.click = function(event) {
        event.preventDefault();

        value = $(event.target).parent().attr('data-value');

        if (value && this.items[value]) {
          this.select(this.items[value]);
        }
      }

      // Show
      this.show = function() {
        var pos = $(this).position();

        $(this).siblings('ul.dropdown-menu').css({
          top: pos.top + $(this).outerHeight(),
          left: pos.left
        });

        $(this).siblings('ul.dropdown-menu').show();
      }

      // Hide
      this.hide = function() {
        $(this).siblings('ul.dropdown-menu').hide();
      }

      // Request
      this.request = function() {
        clearTimeout(this.timer);

        this.timer = setTimeout(function(object) {
          object.source($(object).val(), $.proxy(object.response, object));
        }, 200, this);
      }

      // Response
      this.response = function(json) {
        html = '';

        if (json.length) {
          for (i = 0; i < json.length; i++) {
            this.items[json[i]['value']] = json[i];
          }

          for (i = 0; i < json.length; i++) {
            if (!json[i]['category']) {
              html += '<li data-value="' + json[i]['value'] + '"><a href="#">' + json[i]['label'] + '</a></li>';
            }
          }

          // Get all the ones with a categories
          var category = new Array();

          for (i = 0; i < json.length; i++) {
            if (json[i]['category']) {
              if (!category[json[i]['category']]) {
                category[json[i]['category']] = new Array();
                category[json[i]['category']]['name'] = json[i]['category'];
                category[json[i]['category']]['item'] = new Array();
              }

              category[json[i]['category']]['item'].push(json[i]);
            }
          }

          for (i in category) {
            html += '<li class="dropdown-header">' + category[i]['name'] + '</li>';

            for (j = 0; j < category[i]['item'].length; j++) {
              html += '<li data-value="' + category[i]['item'][j]['value'] + '"><a href="#">&nbsp;&nbsp;&nbsp;' + category[i]['item'][j]['label'] + '</a></li>';
            }
          }
        }

        if (html) {
          this.show();
        } else {
          this.hide();
        }

        $(this).siblings('ul.dropdown-menu').html(html);
      }

      $(this).after('<ul class="dropdown-menu"></ul>');
      $(this).siblings('ul.dropdown-menu').delegate('a', 'click', $.proxy(this.click, this));

    });
  }
})(window.jQuery);

// Runtime fallbacks for third-party floating UI on mobile
(function() {
  function adjustFloatingUi() {
    if (window.innerWidth > 767) return;

    // Move common chat launchers above cookie banner
    var chatSelectors = [
      'button[aria-label*="chat" i]',
      'iframe[title*="chat" i]',
      'iframe[src*="chat" i]'
    ];
    chatSelectors.forEach(function(sel) {
      var nodes = document.querySelectorAll(sel);
      nodes.forEach(function(node) {
        node.style.bottom = '78px';
      });
    });

    // Hide AVADA/Air Reviews floating side tab on mobile.
    var reviewNodes = document.querySelectorAll('iframe, a, button, div, span');
    reviewNodes.forEach(function(el) {
      var src = ((el.getAttribute && (el.getAttribute('src') || '')) || '').toLowerCase();
      var cls = ((el.className && el.className.toString()) || '').toLowerCase();
      var id = ((el.id && el.id.toString()) || '').toLowerCase();
      var txt = ((el.textContent || '')).toLowerCase();
      var isReviewWidget =
        src.indexOf('air-reviews') !== -1 ||
        (src.indexOf('avada') !== -1 && src.indexOf('review') !== -1) ||
        cls.indexOf('air-reviews') !== -1 ||
        id.indexOf('air-reviews') !== -1 ||
        (cls.indexOf('avada') !== -1 && cls.indexOf('review') !== -1) ||
        (id.indexOf('avada') !== -1 && id.indexOf('review') !== -1) ||
        txt.indexOf('our reviews') !== -1;

      if (!isReviewWidget) return;
      el.style.display = 'none';
      el.style.visibility = 'hidden';
      el.style.opacity = '0';
      el.style.pointerEvents = 'none';
    });

    // Nudge right-side "Our Reviews" tab away from edge/content
    var candidates = document.querySelectorAll('a, button, div, span');
    candidates.forEach(function(el) {
      var txt = (el.textContent || '').trim();
      if (txt === 'Our Reviews' || txt.indexOf('Our Reviews') !== -1) {
        el.style.left = 'auto';
        el.style.right = '6px';
        el.style.top = '55%';
        el.style.position = 'fixed';
        el.style.transform = 'scale(0.9)';
        el.style.transformOrigin = 'right center';
        el.style.zIndex = '1200';
        // Keep this third-party tab hidden on mobile to avoid content overlap.
        el.style.display = 'none';
      }
    });

    // Hide tiny right-edge fixed tabs (common review/widget collapsed pills)
    var floatingNodes = document.querySelectorAll('a, button, div, span, iframe');
    floatingNodes.forEach(function(el) {
      if (!el || !el.getBoundingClientRect) return;
      if (el.closest && (el.closest('#crisp-chatbox') || el.closest('.cc-window'))) return;

      var tag = (el.tagName || '').toLowerCase();
      var aria = ((el.getAttribute && (el.getAttribute('aria-label') || '')) || '').toLowerCase();
      var title = ((el.getAttribute && (el.getAttribute('title') || '')) || '').toLowerCase();
      var cls = ((el.className && el.className.toString()) || '').toLowerCase();
      var id = ((el.id && el.id.toString()) || '').toLowerCase();
      var isChatLike = aria.indexOf('chat') !== -1 || title.indexOf('chat') !== -1 || cls.indexOf('chat') !== -1 || id.indexOf('chat') !== -1;
      if (isChatLike) return;

      var style = window.getComputedStyle(el);
      if (!style || style.position !== 'fixed') return;
      if (style.display === 'none' || style.visibility === 'hidden') return;
      if (parseFloat(style.opacity || '1') === 0) return;

      var rect = el.getBoundingClientRect();
      var isTinyPill = rect.width <= 44 && rect.height <= 64;
      var rightEdge = rect.right >= (window.innerWidth - 14);
      var midPage = rect.top > 80 && rect.top < (window.innerHeight - 120);
      var widgetLike = cls.indexOf('review') !== -1 || id.indexOf('review') !== -1 || cls.indexOf('widget') !== -1 || id.indexOf('widget') !== -1;

      if ((isTinyPill && rightEdge && midPage) || (widgetLike && rightEdge && midPage)) {
        el.style.display = 'none';
      }
    });

    // Compact cookie banner if provider injects custom markup
    var cookieNodes = document.querySelectorAll('.cc-window, [class*="cookie"], [id*="cookie"]');
    cookieNodes.forEach(function(el) {
      var txt = (el.textContent || '').toLowerCase();
      if (txt.indexOf('this website uses cookies') !== -1 || txt.indexOf('best experience on our website') !== -1) {
        el.style.padding = '10px 12px';
        el.style.zIndex = '9990';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', adjustFloatingUi);
  } else {
    adjustFloatingUi();
  }

  window.addEventListener('resize', adjustFloatingUi);
  setTimeout(adjustFloatingUi, 1000);
  setTimeout(adjustFloatingUi, 3000);
})();